import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const PersonifyIndexPage = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/integrations/personify/")({
  beforeLoad: () => {
    throw redirect({ to: "/integrations/personify/overview" });
  },
  component: PersonifyIndexPage,
});
